var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMountain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9398 2.60724C12.5302 1.79759 11.4698 1.79759 11.0602 2.60724L8.17941 8.30175C8.21101 8.32749 8.24129 8.35609 8.26994 8.38756L9.84991 10.1226L11.4299 8.38756C11.7447 8.04178 12.2553 8.04178 12.5701 8.38756L14.1501 10.1226L15.7301 8.38756C15.7587 8.35609 15.789 8.32749 15.8206 8.30175L12.9398 2.60724Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6306 9.90295L14.7202 12.0009C14.4053 12.3467 13.8948 12.3467 13.58 12.0009L12 10.2658L10.42 12.0009C10.1052 12.3467 9.59465 12.3467 9.27978 12.0009L7.36937 9.90295L2.13683 20.2461C1.73875 21.033 2.25689 22 3.07659 22H20.9234C21.7431 22 22.2613 21.033 21.8632 20.2461L16.6306 9.90295Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/mountain.a1275b015abde088fe15ee59c51493bf.svg";
export { ForwardRef as ReactComponent };